import styled from "styled-components";
import { device } from "@theme";

export const SectionWrap = styled.div`
    padding-bottom: 20px;
    @media ${device.medium}{
        padding-bottom: 20px;
    }
`;